module.exports = __webpack_public_path__ + "static/media/logo_gato_texto.dfabbc3e.png";